import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import reportWebVitals from './reportWebVitals'
import 'bootstrap/dist/css/bootstrap.min.css'
import ReactPixel from 'react-facebook-pixel'
import './index.css'

//ReactPixel.init('870737606664426', {}, { debug: true, autoConfig: true })
ReactPixel.fbq('init', '870737606664426')
ReactPixel.fbq('track', 'PageView')

ReactDOM.render(
  <App />,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
